import React from "react";
import {langFirebaseService} from "../../jwt/firebase/firebaseGenericService";

export const langFirebaseProvider = {
    getOptions
};

async function getOptions(){
    try {
        let _result = [];
        const listItems = await langFirebaseService.getList();
        Object.entries(listItems).map(([key, value]) => (
            _result.push(value)
        ))

        _result.sort((a, b) =>  a.showOrder - b.showOrder);
        return _result.map((item) => {
            return (
                {
                    id: item.code,
                    value: item.code ,
                    label: <label> <b>{ item.code.toUpperCase() }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}